import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { QueryOptionsType } from 'types';
import axiosInstance from 'utils/axios';

import { QUERY_KEYS } from 'api/certificates/queries';
import { Hello } from 'api/utility/utility.model';
import { apiEndpoints } from 'apiEndpoints';

export const useApiConnectionQuery = (options?: QueryOptionsType<Hello>) =>
  useQuery<undefined, AxiosError<Hello>, Hello>(
    [QUERY_KEYS.HELLO],
    async () => {
      const { data: hello } = await axiosInstance.get(apiEndpoints.utils.hello, {
        timeout: 2000,
      });
      return hello;
    },
    options
  );
